import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-24 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-3">
          {/* Image Side */}
          <div className="w-full lg:w-1/2" data-id="element-4">
            <div className="relative" data-id="element-5">
              <div className="absolute -inset-4 bg-brand-offwhite rounded transform -rotate-3 z-0" data-id="element-6"></div>
              <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80" alt="Bill Cornacchia on job site" className="relative z-10 w-full h-[500px] object-cover rounded shadow-lg" data-id="element-7" />
              <div className="absolute -bottom-6 -right-6 bg-brand-blue text-white p-6 rounded shadow-xl z-20 hidden md:block" data-id="element-8">
                <p className="text-3xl font-bold mb-1" data-id="element-9">28+</p>
                <p className="text-sm font-medium tracking-wide text-gray-300 uppercase" data-id="element-10">
                  Years Building
                </p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2" data-id="element-11">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6" data-id="element-12">
              Built by Bill Cornacchia
            </h2>
            <div className="space-y-6 text-lg text-brand-gray mb-10 font-body leading-relaxed" data-id="element-13">
              <p data-id="element-14">
                Bill has been remodeling Fresno homes since 1997. As a fully
                licensed, insured, and bonded general contractor (CA License
                #947943), he brings decades of hands-on expertise to every
                project.
              </p>
              <p data-id="element-15">
                Unlike large corporate firms where you're passed off to a
                project manager, Bill manages every job personally. From the
                initial consultation to the final walkthrough, you work directly
                with the owner.
              </p>
              <p data-id="element-16">
                We believe in straight answers, honest pricing, and
                craftsmanship that stands the test of time. No pressure. No
                obligation. Just quality work for our neighbors in Fresno and
                the surrounding counties.
              </p>
            </div>
            <a href="#about-full" className="inline-block bg-brand-blue text-white hover:bg-blue-800 px-8 py-4 font-bold transition-colors" data-id="element-17">
              Learn More About BLC
            </a>
          </div>
        </div>
      </div>
    </section>;
}